import Image from "next/image";
import { Stack, Text, HStack } from "@chakra-ui/react";
import CloudServicesImg from "public/cloud-services/cloud-services.png";
import TickImage from "public/shared/blueCheck.jpeg";
import { useTextVariants } from "@/theme/components/useSectionHeading";

type IntroProps = {
  description: string[];
  points: string[];
};

const Content = (props: IntroProps) => {
  const { description, points } = props;
  const textVariant = useTextVariants();
  return (
    <Stack>
      <Stack>
        {description.map((desc, index) => (
          <Text variant={textVariant} key={index} color="text.100">
            {desc}
          </Text>
        ))}
      </Stack>
      <Stack spacing={1} color="text.100">
        {points.map((point, index) => (
          <HStack key={index}>
            <Image
              alt={"Point"}
              src={TickImage}
              style={{ height: "auto", width: "20px" }}
            />{" "}
            <Text variant={textVariant} fontWeight={550}>
              {point}
            </Text>
          </HStack>
        ))}
      </Stack>
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  title: "What are Cloud Services? ",
  description: (
    <Content
      description={[
        "Cloud services provide on-demand computing resources, allowing businesses to store, process, and manage data without investing in physical infrastructure. Organizations leverage cloud solutions to enhance flexibility, scalability, and security while optimizing costs. ",
        "With Onemind's Cloud Services, businesses can choose between Private Cloud for dedicated infrastructure or POC Cloud for agile testing and validation. ",
      ]}
      points={[
        " High-performance infrastructure",
        " Scalable and cost-effective solutions ",
        " Enterprise-grade security ",
      ]}
    />
  ),
  image: CloudServicesImg,
};
